import axios, { AxiosError } from "axios";
import urlJoin from "url-join";
import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../../../core/config/Config";
import SystemMessageBuilder from "../../../core/system-message/controller/SystemMessageBuilder";
import SystemMessageEvent from "../../../core/system-message/model/SystemMessageEvent";
import NGTConfigKey from "../../../ngt/base/NGTConfigKey";
import PlatformUserService from "../controller/PlatformUserService";
import PlatformUserModel from "../model/PlatformUserModel";

export default class AuthenticatePlatformTask extends Task {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher
     * @param {PlatformUserService} platformUserService
     * @param {PlatformUserModel} platformUserModel
     * @param {Config} config
     * @param {LanguagePack} languagePack
     */
    constructor(dispatcher, platformUserService, platformUserModel, config, languagePack) {
        super();

        this._dispatcher = dispatcher;
        this._platformUserService = platformUserService;
        this._platformUserModel = platformUserModel;
        this._config = config;
        this._languagePack = languagePack;

        this._platformGameApiEndpoint = this._config.getValue(NGTConfigKey.PLATFORM_API_ENDPOINT);
        this._apiVersion = this._config.getValue(NGTConfigKey.PLATFORM_API_VERSION);
    }

    async execute(callback) {
        try {
            await this.authenticateWithPlatform();
        } catch (error) {
            /** @type {AxiosError} */
            const axiosError = error;

            const systemMessage = new SystemMessageBuilder()
                .setTitle(this._languagePack.getText(`platformErrors.gameSessionError.title`))
                .setDescription(`${this._languagePack.getText(`platformErrors.gameSessionError.description`)}`)
                .build();

            const evt = new SystemMessageEvent(SystemMessageEvent.OPEN, systemMessage);
            this._dispatcher.dispatch(evt.type, { data: evt });

            throw error;
        }

        callback();
    }

    async authenticateWithPlatform() {
        const url = new URL(window.location.href);
        const sessionId = url.searchParams.get('sessionId');
        if (!sessionId) {
            throw new Error('Session ID is missing in the URL query parameters.');
        }

        const hash = window.location.hash;
        const fragmentString = hash.slice(1); // Remove the leading '#'
        const fragments = new URLSearchParams(fragmentString);
        const accessToken = fragments.get('access_token');
        if (!accessToken) {
            throw new Error('Access token is missing in the URL fragment.');
        }

        // TODO: verify access_token against Entra ID.
        // TODO

        // Configures platform user service.
        this._platformUserService.setAccessToken(accessToken);

        // Initialize platform user model with data from the platform API.
        const platformGameApiClient = axios.create({
            baseURL: urlJoin(this._platformGameApiEndpoint, this._apiVersion),
        });

        const gameSessionResponse = await platformGameApiClient.get(`game-sessions/${sessionId}`);

        // Populate user model.
        const { learnerId, status, name } = gameSessionResponse.data;
        this._platformUserModel.id = learnerId;
        this._platformUserModel.name = name;
        this._platformUserModel.completionStatus = status;
        this._platformUserModel.sessionId = sessionId;

        // Store in session storage.
        // sessionStorage.setItem('sessionId', sessionId);
        // sessionStorage.setItem('accessToken', accessToken);
    }
}
